import { render, staticRenderFns } from "./ServicesOrigami.vue?vue&type=template&id=6969172a&scoped=true&"
import script from "./ServicesOrigami.vue?vue&type=script&lang=js&"
export * from "./ServicesOrigami.vue?vue&type=script&lang=js&"
import style0 from "./ServicesOrigami.vue?vue&type=style&index=0&id=6969172a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6969172a",
  null
  
)

export default component.exports